import React from 'react';
import FilterTable from './filterTable';
import { Link } from 'react-router-dom';

const WrongActivationsHistoryTable = props => {
  const columns = [ {
    dataField: 'connectionDateTime',
    text: 'Event time',
    sort: true,
    filter_: { type: 'datetime' },
    defaultDisplayed: true,
    headerStyle: () => ({
      minWidth: '8em',
      maxWidth: '11em'
    })
  }, {
    dataField: 'device.key',
    text: 'Device key',
    filter_: { type: 'text' },
    formatter: (cell) => {
      return (<Link to={`/history?device.key=${cell}`}>{cell}</Link>)
    }
  }, {
    dataField: 'deviceKeyList',
    text: 'Request device keys',
    sort: true,
    filter_: { type: 'text' },
    defaultDisplayed: true
  }, {
    dataField: 'inputLicenseKey',
    text: 'Request license key',
    sort: true,
    filter_: { type: 'text' },
    defaultDisplayed: true,
    headerStyle: () => ({ maxWidth: '15em' }),
    formatter: (cell) => {
      return (<Link to={`/permanent-licenses?license.key=${cell}`}>{cell}</Link>)
    }
  },];

  const defaultSorted = [{
    dataField: 'eventDateTime',
    order: 'desc'
  }];

  return (
    <FilterTable
      {...props}
      objectName="wrongActivationsHistory"
      data={props.history}
      columns={columns}
      defaultSorted={defaultSorted}
      noDataIndication="There are no wrong activations history records"
    />
  );
};

export default WrongActivationsHistoryTable;



// WEBPACK FOOTER //
// ./src/components/wrongActivationsHistoryTable.js